/** Provincias (y ciudades autónomas) de España — orden aprox. alfabético para desplegables. */
export const PROVINCIAS_ES = [
  'A Coruña', 'Álava', 'Albacete', 'Alicante', 'Almería', 'Asturias', 'Ávila', 'Badajoz', 'Balears', 'Barcelona', 'Burgos', 'Cáceres', 'Cádiz', 'Cantabria', 'Castellón', 'Ceuta', 'Ciudad Real', 'Córdoba', 'Cuenca', 'Girona', 'Granada', 'Guadalajara', 'Gipuzkoa', 'Huelva', 'Huesca', 'Jaén', 'La Rioja', 'Las Palmas', 'León', 'Lleida', 'Lugo', 'Madrid', 'Málaga', 'Melilla', 'Murcia', 'Navarra', 'Ourense', 'Palencia', 'Pontevedra', 'Salamanca', 'Santa Cruz de Tenerife', 'Segovia', 'Sevilla', 'Soria', 'Tarragona', 'Teruel', 'Toledo', 'Valencia', 'Valladolid', 'Bizkaia', 'Zamora', 'Zaragoza',
];

export const PAISES_COMUN = [
  { v: 'ES', l: 'España' },
  { v: 'PT', l: 'Portugal' },
  { v: 'FR', l: 'Francia' },
  { v: 'AD', l: 'Andorra' },
  { v: 'IT', l: 'Italia' },
  { v: 'DE', l: 'Alemania' },
  { v: 'UK', l: 'Reino Unido' },
  { v: 'OT', l: 'Otro' },
];
